import type { CSSProperties } from 'react';

interface Props {
  position: 'top-right' | 'bottom-center';
  size?: number;
  /** 0–100 — peak opacity of the glow center */
  intensity?: number;
  color?: string;
}

/**
 * Diffuse light halo — web port of the legacy `LightHalo`. The RN version
 * stacked concentric translucent circles; on web a single blurred
 * radial-gradient reproduces the same continuous glow far more cheaply.
 */
const LightHalo = ({
  position,
  size = 300,
  intensity = 40,
  color = 'var(--tw-color-white)',
}: Props) => {
  const positionStyle: CSSProperties =
    position === 'top-right'
      ? { top: -size / 2, right: -size / 2 }
      : { bottom: -size / 1.5, left: '50%', transform: 'translateX(-50%)' };

  const peak = Math.max(0, Math.min(100, intensity)) / 100;

  return (
    <div
      aria-hidden="true"
      className="tw:pointer-events-none tw:absolute tw:rounded-full"
      style={{
        width: size,
        height: size,
        filter: 'blur(80px)',
        // Fades to `transparent` rather than concatenating an "00" alpha onto the
        // hex: that trick forced a literal color here and rejected any token.
        background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        opacity: peak,
        ...positionStyle,
      }}
    />
  );
};

export default LightHalo;
